export default __webpack_public_path__ + "static/media/DashboardEmployer.2c93eda1.svg";